<template>
  <ul class="sm:-mx-6 yacht-itinerary-list">
    <li v-for="(itinerary, index) in itineraries" :key="itinerary.id">
      <itinerary-item class="mb-16"
        :itinerary="itinerary"
        :index="index"
        @enquire-click="handleEnquireClick" />
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import ItineraryItem from './ItineraryItem'
import get from 'lodash/get'

export default {
  components: {
    ItineraryItem,
  },
  props: ['countrySku', 'countrySlug'],
  computed: {
    ...mapState(['supplier']),
    itineraries() {
      return get(this.supplier, 'itineraries', [])
    }
  },
  methods: {
    handleEnquireClick (id) {
      const params = `?id=${this.supplier.supplier.id}&itineraryId=${id}`
      window.location.href = `/enquiry/charter-yacht${params}`
    }
  }
}
</script>
<style scoped>
.liveaboard-nav-button:disabled {
  background-color: var(--black-light-1);
}

@media (max-width: 600px) {
  .trip-separator {
    height: 16px;
    background-color: #F6F6F6;
    border: 0px;
  }

  .yacht-itinerary-list li:last-of-type hr {
    display: none;
  }

  .itinerary-list-header {
    padding-top: 24px;
    padding-bottom: 24px;
    align-items: flex-start;
    height: auto;
  }

  .liveaboard-nav-button {
    border: 1px solid #dcdcdc;
  }
}
</style>
